<script setup lang="ts">
import { onBeforeMount } from 'vue';
import GHostModal from './components/common/dialog/GHostModal.vue';
import GLoader from './components/layout/GLoader.vue';
import { useAuthStore } from './stores/auth';
import { useCompanyStore } from './stores/company';
import { useLoadingStore } from './stores/loading';
import { companyService } from './services/company';

const loadingStore = useLoadingStore();

onBeforeMount(async () => {
  useCompanyStore().company = await companyService.getInfo();
  useAuthStore().init();
})

</script>

<template>
  <div class="app-box" :class="{ blur: loadingStore.isLoading }">
    <router-view />
  </div>

  <GLoader></GLoader>

  <GHostModal></GHostModal>

</template>

<style lang="scss" scoped>
.app-box {
  transition: filter 0.3s ease;
}
</style>
